import React, {Component} from 'react';
import {CardList} from './components/card-list/card-list.component';
import {SearchBox} from './components/search-box/search-box.component';
import './App.css';

class App extends Component
{
  constructor()
  {
    super(); // This initializes the parent constructor

    // This is the internal state
    this.state = {
      monsters: [],
      searchField: "",
    };

    //this.handleChange = this.handleChange.bind(this);

  }
  //https://jsonplaceholder.typicode.com/users
  componentDidMount() // This is a lifecycle method
  {
    fetch("http://admin.colorgraphicz.in/api/categories").then(response => response.json()).then(users => this.setState({monsters:users}) );
  }

  handleChange = (event) => this.setState({searchField:event.target.value});


  render(){
    const {monsters,searchField} = this.state; // this is called destructuring
    const filteredMonsters = monsters.filter(monster=>monster.name.toLowerCase().includes(searchField.toLowerCase()));
      return (
        <div className="App">
          <h1>Robot Rolodex</h1>
          <SearchBox placeholder="Search Robots" handleChange={this.handleChange} />
          <CardList monsters={filteredMonsters} />
        </div>
      );
  }
}

export default App;
